module.exports = __webpack_public_path__ + "static/img/6.324fe128.png";